import type { Row, Table } from '@tanstack/react-table';

const INTERACTIVE_ROW_TARGETS =
  'button, a, input, select, textarea, [role="button"], [role="link"], [contenteditable="true"]';

export const handleDataGridRowClick = <T extends Record<string, unknown>>(
  target: HTMLElement,
  row: Row<T>,
  table: Table<T>,
  isSelectableGrid: boolean
) => {
  if (target.closest('input[type="checkbox"]')) return;
  if (target.closest('td[data-col-id="_selection"]')) {
    row.toggleSelected();
    return;
  }
  if (target.closest('td[data-col-id="_actions"]')) return;

  if (isSelectableGrid) {
    table.setRowSelection({ [row.id]: true });
  }
  if (target.closest(INTERACTIVE_ROW_TARGETS)) return;

  table.options.meta?.onRowActivate?.(row.original);
};
